<template>
  <v-item-group
    style="height:100%;"
    mandatory
    v-model="filterParams.range"
    @change="setDates()"
  >
    <v-row>
      <v-spacer />
      <v-col class="pa-0 flex-grow-0">
        <v-item
          v-slot:default="{ active, toggle }"
          class="my-1 mr-1"
          value="Last Week"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-last-week"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >Last Week</v-btn
          >
        </v-item>

        <v-item
          v-slot:default="{ active, toggle }"
          class="mb-1 mr-1"
          value="Last Year"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-last-year"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >Last Year</v-btn
          >
        </v-item>
      </v-col>
      <v-col class="pa-0 flex-grow-0">
        <v-item
          v-slot:default="{ active, toggle }"
          class="my-1 mr-1"
          value="Yesterday"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-yesterday"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >Yesterday</v-btn
          >
        </v-item>

        <v-item
          v-slot:default="{ active, toggle }"
          class="mb-1 mr-1"
          value="Last Month"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-last-month"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >Last Month</v-btn
          >
        </v-item>
      </v-col>
      <v-col class="pa-0 flex-grow-0">
        <v-item v-slot:default="{ active, toggle }" class="my-1 mr-1" value="Today">
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-today"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >Today</v-btn
          >
        </v-item>
        <v-item
          v-slot:default="{ active, toggle }"
          class="mb-1 mr-1"
          value="This Month"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-this-month"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >This Month</v-btn
          >
        </v-item>
      </v-col>
      <v-col class="pa-0 flex-grow-0">
        <v-item
          v-slot:default="{ active, toggle }"
          class="my-1"
          value="This Week"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-this-week"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >This Week</v-btn
          >
        </v-item>
        <v-item
          v-slot:default="{ active, toggle }"
          class="mb-1"
          value="This Year"
        >
          <v-btn
            class="text-capitalize"
            tile
            elevation="0"
            :width="blockWidth"
            id="filter-this-year"
            :style="
              active
                ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                : ''
            "
            @click="toggle"
            >This Year</v-btn
          >
        </v-item>
      </v-col>
      <v-spacer />
    </v-row>
    <v-item v-slot:default="{ toggle }" value="Custom Dates">
      <v-row class="mx-9 mt-10">
        <v-col class="pl-0 py-0">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                dense
                v-model="filterParams.start_date"
                label="Start Date"
                id="input-start-date"
                append-icon="mdi-calendar-blank"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterParams.start_date"
              no-title
              @change="toggle"
              @input="startMenu = false"
              id="start-date-picker"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pr-0 py-0">
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                dense
                v-model="filterParams.end_date"
                label="End Date"
                id="input-end-date"
                append-icon="mdi-calendar-blank"
                v-on="on"
                :rules="[rules.afterStart]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterParams.end_date"
              no-title
              @change="toggle"
              :min="filterParams.start_date"
              @input="endMenu = false"
              id="end-date-picker"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-item>
  </v-item-group>
</template>
<script>
import moment from 'moment';
import FilterParameters from '@/mixins/FilterParams.js';
import { MobileView } from '@/mixins';

export default {
  mixins: [FilterParameters, MobileView],
  props: {
    range: String,
  },
  data() {
    return {
      startMenu: false,
      endMenu: false,
      rules: {
        afterStart: () => moment(this.filterParams.start_date).isBefore(
          moment(this.filterParams.end_date),
        ) || 'End date must be later than start date',
      },
    };
  },
  computed: {
    blockWidth() {
      if (this.showMobileView) {
        return '84';
      }
      return '99';
    },
  },
  methods: {
    setDates() {
      let time;
      let startOfMonth;
      let endOfMonth;
      let startOfYear;
      let endOfYear;
      let startOfWeek;
      let endOfWeek;
      switch (this.filterParams.range) {
        case 'Today':
          time = moment().format('YYYY-MM-DD');
          this.filterParams.start_date = time;
          this.filterParams.end_date = moment()
            .add(1, 'day')
            .format('YYYY-MM-DD');
          break;
        case 'Yesterday':
          time = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = time;
          this.filterParams.end_date = moment(time)
            .add(1, 'day')
            .format('YYYY-MM-DD');
          break;
        case 'This Month':
          startOfMonth = moment()
            .startOf('month')
            .format('YYYY-MM-DD');
          endOfMonth = moment()
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfMonth;
          this.filterParams.end_date = endOfMonth;
          break;
        case 'This Year':
          startOfYear = moment()
            .startOf('year')
            .format('YYYY-MM-DD');
          endOfYear = moment()
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfYear;
          this.filterParams.end_date = endOfYear;
          break;
        case 'Last Week':
          startOfWeek = moment()
            .subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          endOfWeek = moment()
            .subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfWeek;
          this.filterParams.end_date = endOfWeek;
          break;
        case 'Last Month':
          startOfMonth = moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('YYYY-MM-DD');
          endOfMonth = moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfMonth;
          this.filterParams.end_date = endOfMonth;
          break;
        case 'This Week':
          startOfWeek = moment()
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          endOfWeek = moment()
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfWeek;
          this.filterParams.end_date = endOfWeek;
          break;
        case 'Last Year':
          startOfYear = moment()
            .subtract(1, 'years')
            .startOf('year')
            .format('YYYY-MM-DD');
          endOfYear = moment()
            .subtract(1, 'years')
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.start_date = startOfYear;
          this.filterParams.end_date = endOfYear;
          break;
        default:
          break;
      }
    },
  },
};
</script>
